var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card-title',{staticClass:"text-uppercase pa-0 ma-0 mb-2"},[_c('span',[_vm._v(_vm._s(_vm.tournament.name))])])}
var staticRenderFns = []

export { render, staticRenderFns }